import React from 'react';
import PropTypes from 'prop-types';
import each from "lodash/each";
import reject from "lodash/reject";
import sortBy from "lodash/sortBy";
import map from "lodash/map";
import get from "lodash/get";
import dropdownNavigationHOC from '../dropdown-navigation-hoc';
import { findAll } from 'highlight-words-core';
import { FormattedMessage } from 'react-intl';

const ListContainer = ({ children }) => (
  <ul
    tabIndex="-1"
    role="listbox"
    className="dropdown-list"
    aria-labelledby={null}
    style={{ minWidth: '220px', margin: '0 -1px' }}
  >
    { children }
  </ul>
);

const ErrorDropdown = ({ toggleModal, listToggle }) => (
  <ListContainer>
    <div style={{ padding: '16px' }}>
      <div>
        <FormattedMessage
          id="search.error_dropdown.dont_recognize_activity"
          defaultMessage="We don't recognize that activity. Try describing it differently or"
        />
        &nbsp;
        <span
          role="button"
          className="btn-link remove-click-styling no-gutter text-left"
          onClick={(e) => { toggleModal(e, listToggle); }}
        >
          <FormattedMessage id="search.error_dropdown.popular_activities" defaultMessage="pick from popular activities." />
        </span>
      </div>
    </div>
  </ListContainer>
);

const ActivityList = dropdownNavigationHOC(({
  data,
  inputShownValue,
  clickActivity,
  listToggle,
  index,
  onKeyDownList,
  hideDefaultHighlight
}) => {
  const dropdown = get(data, 'dropdown', '');
  const chunks = findAll({
    caseSensitive: false,
    textToHighlight: dropdown,
    autoEscape: true,
    searchWords: [inputShownValue]
  });

  const highlightedText = map(chunks, (chunk) => {
    const { end, highlight, start } = chunk;
    const text = dropdown.substr(start, end - start);

    if (highlight) {
      return <b className="text-gray-darker">{text}</b>;
    }
    return <span>{text}</span>;
  });

  return (
    <li
      key={data.id}
      id={`activity-list-${index}`}
      tabIndex="0"
      role="option"
      aria-selected="true"
      className={`border-bottom ${0 === index && !hideDefaultHighlight && 'gray-light-bg'}`}
      data-value={data.id}
      onClick={(e) => { clickActivity(e, listToggle); }}
      onKeyDown={onKeyDownList}
      style={{ padding: '10px 16px' }}
    >
      <div className="ellipsis capitalize-first-letter">
        <div>{highlightedText}</div>
      </div>
    </li>
  );
});

const ActivitiesDropdown = ({ activitiesList, ...props }) => {
  return (
    <ListContainer>
      {
        [
          map(activitiesList, (data, index) => {
            return (
              <ActivityList
                key={data.nickname}
                data={data}
                index={index}
                {...props}
              />
            );
          }),
          props.hideModalLink ? null
            : <div tabIndex="-1" style={{ padding: '10px 16px' }}>
              <button
                className="btn-link remove-click-styling no-gutter"
                onClick={(e) => { props.toggleModal(e, props.listToggle); }}
              >
                <FormattedMessage id="search.activities_dropdown.popular_activities" defaultMessage="See all popular activities" />
              </button>
            </div>
        ]
      }
    </ListContainer>
  );
};

export const SearchActivityDropdown = ({ ...props }) => {
  const Component = props.activitiesList.length ? ActivitiesDropdown : !props.hideErrorDropdown && ErrorDropdown;
  return Component && <Component {...props} />;
};


ErrorDropdown.propTypes = {
  listToggle: PropTypes.func,
  toggleModal: PropTypes.func
};

ActivityList.propTypes = {
  clickActivity: PropTypes.func.isRequired,
  data: PropTypes.object,
  inputShownValue: PropTypes.string,
  listToggle: PropTypes.func,
  index: PropTypes.number,
  onKeyDownList: PropTypes.number,
  hideDefaultHighlight: PropTypes.bool
};

ActivitiesDropdown.propTypes = {
  activitiesList: PropTypes.array,
  listToggle: PropTypes.func,
  toggleModal: PropTypes.func
};

ListContainer.propTypes = {
  children: PropTypes.node.isRequired
};

SearchActivityDropdown.propTypes = {
  activitiesList: PropTypes.array
};
